import request from '@/request/request'

// 查询报警规则列表
export function listWarnRule(query) {
    return request({
        url: '/api/equipment-server/warnRule/list',
        method: 'get',
        params: query
    })
}

// 查询报警规则详细
export function getWarnRuleById(id) {
    return request({
        url: '/api/equipment-server/warnRule/' + id,
        method: 'get'
    })
}

// 新增报警规则
export function addWarnRule(data) {
    return request({
        url: '/api/equipment-server/warnRule',
        method: 'post',
        data: data
    })
}

// 修改报警规则
export function updateWarnRule(data) {
    return request({
        url: '/api/equipment-server/warnRule/edit',
        method: 'post',
        data: data
    })
}

// 删除报警规则
export function delWarnRule(id) {
    return request({
        url: '/api/equipment-server/warnRule/delete/' + id,
        method: 'post'
    })
}

